import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { BiBasketball, BiUserCircle } from 'react-icons/bi';
import { MdOutlineContactSupport, MdOutlineVerifiedUser } from 'react-icons/md';
import { AiOutlineDownload } from 'react-icons/ai';

const NavItem = ({ to, icon: Icon, label }) => {
  const [hovered, setHovered] = useState(false)

  return (
    <NavLink to={to} style={{ textDecoration: 'none' }}>
      {({ isActive }) => (
        <div
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '3px',
            padding: '6px 10px',
            minWidth: '64px',
            minHeight: '56px',
            borderRadius: '8px',
            background: isActive
              ? 'linear-gradient(135deg, #facc15, #fde68a)'
              : hovered
              ? 'rgba(250,204,21,0.08)'
              : 'transparent',
            border: isActive
              ? '1px solid #facc15'
              : hovered
              ? '1px solid rgba(250,204,21,0.3)'
              : '1px solid transparent',
            color: isActive ? '#111' : hovered ? '#facc15' : '#9ca3af',
            fontWeight: 700,
            fontSize: '11px',
            textTransform: 'uppercase',
            letterSpacing: '0.08em',
            boxShadow: isActive
              ? '0 0 16px rgba(250,204,21,0.35)'
              : hovered
              ? '0 0 12px rgba(250,204,21,0.15)'
              : 'none',
            transform: hovered && !isActive ? 'translateY(-2px)' : 'translateY(0)',
            transition: 'all 0.22s cubic-bezier(0.34,1.56,0.64,1)',
            cursor: 'pointer',
            position: 'relative',
            overflow: 'hidden',
          }}
        >
          {/* shimmer sweep */}
          <span style={{
            position: 'absolute',
            top: 0,
            left: hovered && !isActive ? '110%' : '-60%',
            width: '45%',
            height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(250,204,21,0.18), transparent)',
            transition: 'left 0.45s ease',
            pointerEvents: 'none',
          }} />

          <Icon style={{
            fontSize: '18px',
            transform: hovered ? 'scale(1.18) translateY(-1px)' : 'scale(1)',
            transition: 'transform 0.22s ease',
          }} />
          <span>{label}</span>

          {/* active indicator dot */}
          {isActive && (
            <span style={{
              position: 'absolute',
              bottom: '4px',
              left: '50%',
              transform: 'translateX(-50%)',
              width: '4px',
              height: '4px',
              borderRadius: '50%',
              background: '#111',
            }} />
          )}
        </div>
      )}
    </NavLink>
  )
}

const ResumeNavItem = () => {
  const [hovered, setHovered] = useState(false)
  return (
    <a
      className='md:hidden'
      target='_blank'
      rel='noopener noreferrer'
      href='https://drive.google.com/file/d/1_gDTiZTfp9m3BHUT5zqWyJy3Sqq_2jzH/view?usp=share_link'
      download=''
      style={{ textDecoration: 'none' }}
    >
      <div
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '3px',
          padding: '6px 10px',
          minWidth: '64px',
          minHeight: '56px',
          borderRadius: '8px',
          background: hovered ? 'rgba(250,204,21,0.08)' : 'transparent',
          border: hovered ? '1px solid rgba(250,204,21,0.3)' : '1px solid transparent',
          color: hovered ? '#facc15' : '#9ca3af',
          fontWeight: 700,
          fontSize: '11px',
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          transform: hovered ? 'translateY(-2px)' : 'translateY(0)',
          transition: 'all 0.22s cubic-bezier(0.34,1.56,0.64,1)',
          cursor: 'pointer',
        }}
      >
        <AiOutlineDownload style={{
          fontSize: '18px',
          transform: hovered ? 'scale(1.18) translateY(-1px)' : 'scale(1)',
          transition: 'transform 0.22s ease',
        }} />
        <span>Resume</span>
      </div>
    </a>
  )
}

const Nav = () => (
  <div className='flex items-center justify-center md:gap-2 gap-1'>
    <NavItem to='/about'     icon={BiUserCircle}          label='About'   />
    <NavItem to='/portfolio' icon={BiBasketball}           label='Work'    />
    <NavItem to='/skills'    icon={MdOutlineVerifiedUser}  label='Skills'  />
    <ResumeNavItem />
    <NavItem to='/contact'   icon={MdOutlineContactSupport} label='Contact' />
  </div>
)

export default Nav;
